
import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import './index.scss'

interface ModalProps {
    visible?:boolean //是否显示弹框
    title?:React.ReactNode | string //弹窗标题
    cancelText?:string //取消按钮的文字
    okText?:string //确认按钮文字
    isCancelBtn?:boolean //是否显示取消按钮
    content?:React.ReactNode | string //弹窗内容
    onOk?: () => void // 确定按钮的回调
    onCancel?: () => void // 确定按钮的回调
    style?: any // 样式
    loading?:boolean //是否加载中
    isAutomaticDown?:number //倒计时关闭
    isCountdown?:boolean //是否自动关闭
}
export class Modal extends React.Component<ModalProps, any> {
    time = null
    static defaultProps = {
        cancelText: '取消',
        okText: '确认',
        isCancelBtn:true,
        loading:false,
        onOk: () => { }, // 确认
        onCancel: () => { }, // 取消
        isCountdown:false
    }
    constructor(props: ModalProps) {
        super(props);
        this.state = {
            num:0
        }
    }
    componentDidMount() {
        if( this.props?.isAutomaticDown && this.props?.isCountdown ) {
            this.setState({
                num:this.props.isAutomaticDown
            })
            this.time = setInterval(async() => {
                this.setState({
                    num:this.state.num - 1
                })
                if( !this.state?.num || this.state.num === 0 ) {
                    clearInterval(this.time)
                    if(this.props.onCancel) {
                        this.props.onCancel()
                    }
                    modal.destroy()
                }
            },1000)
        }
    }
    render() {
        const { visible, title, content, cancelText, okText, isCancelBtn, loading, style, children, isCountdown } = this.props
        const { num } = this.state
        if( !visible ) {
            return null
        }
        return (
            <div className={`a-modal-wrapper ${visible ? 'fade' : 'hide'} `}>
                <div className='a-modal-wrapper-content' style={style || {}}>
                    <p className='a-modal-wrapper-content-title'>{title}</p>
                    <div className='a-modal-wrapper-content-content'>{content || children}</div>
                    <div className='a-modal-wrapper-content-btn'>
                        {isCancelBtn && <div className='a-modal-wrapper-content-btn-cancel' onClick={this.handleCancel.bind(this)}>{cancelText}</div>}
                        <div className='a-modal-wrapper-content-btn-ok' onClick={this.handleOk.bind(this)}> {loading && <i className='a-modal-wrapper-loading'></i>} 
                            {isCountdown && <span style={{'color':'rgba(26, 27, 28, 1)','fontSize':'.3733rem','fontWeight':'bold'}}>{num}s</span>}
                            <span style={{'color':`${isCountdown ? 'rgba(130, 131, 132, 1)' : ''}`}}>{okText}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    handleCancel() {
        if(this.props.onCancel) {
            this.props.onCancel()
        }
    }
    handleOk() {
        if( this.props.loading ) {
            return
        }
        if( this.props?.isAutomaticDown ) {
            return
        }
        if(this.props.onOk) {
            this.props.onOk()
        }
    }
}


export default Modal

export const modal = (options) => {
    const _div = document.getElementById('modal-id')
    if (_div) {
        ReactDOM.render(null, _div)
        document.body.removeChild(_div)
    }
    let div = document.createElement('div')
    div.id = 'modal-id'
    document.body.appendChild(div);
    const ModalHook = (props) => {
        const [visible, setVisible] = useState(true)
        const [loading, setLoading] = useState(false)

        const onCancel = () => {
            setVisible(false)
            modal.destroy()
            if(options.onCancel) {
                options.onCancel()
            }
        }
        useEffect(() => {
        }, [props]);
        const onOk = async () => {
            try {
                if(options?.isLoading) {
                    setLoading(true)
                }
                const data = await options.onOk()
                setLoading(false)
                setVisible(false)
                modal.destroy()
            } catch (error) {
                setVisible(false)
            }
        }
        return <Modal visible={visible} {...options} loading={loading} onCancel={onCancel} onOk={onOk} />
    }

    ReactDOM.render(<ModalHook />, div)
}

modal.destroy = () => {
    const div = document.getElementById('modal-id')
    if (div) {
        ReactDOM.render(null, div)
        document.body.removeChild(div)
    }
}
